module.exports = __webpack_public_path__ + "img/logo1.2c4aeb42.png";